import { render, staticRenderFns } from "./ContractVersionsWidget.vue?vue&type=template&id=47304e1c&scoped=true&"
import script from "./ContractVersionsWidget.vue?vue&type=script&lang=js&"
export * from "./ContractVersionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContractVersionsWidget.vue?vue&type=style&index=0&id=47304e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47304e1c",
  null
  
)

export default component.exports